import React, { useState } from 'react';
import { useParams } from 'react-router';
import DemoProjects from './DemoProjects';
import "./ProjectDetails.css"
const ProjectDetails = () => {
    const { idd } = useParams()
    console.log(idd);
    const [project] = useState(
        DemoProjects.filter(x => x.id == idd)
    )
    const { name, image, description, technology, live, client, backend } = project[0];
    console.log(name);
    return (
        <div className="pdetails">
            <div className="pdetails-in">
                <div className="pinn">
                    <div>
                        <img width="100%" className="dimg" src={image} alt="" />
                    </div>
                    <div className="dae">
                        <h1>Wep Site - {name}</h1>
                        <h4>Description - {description}</h4>
                        <h3>Technology I used - {technology}</h3>
                        <a href={live} target="_blank" rel="noreferrer"><button className="btne">view Live Site</button></a>
                        <a href={client} target="_blank" rel="noreferrer"><button className="btne">view Client site Code</button></a>
                        <a href={backend} target="_blank" rel="noreferrer"><button className="btne">view Backend site Code</button></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetails;